import { Box, createStyles } from '@mantine/core';
import { isEmpty } from 'lodash/fp';
import React from 'react';

import { AwsDeviceTelemetryType } from '@portals/api/organizations';
import { EmptyState } from '@portals/table';
import { prettyTime } from '@portals/utils';

import { TelemetryIcon } from './TelemetryIcon';
import { TelemetryItem } from './TelemetryItem';

interface AwsTelemetryListProps {
  telemetries: AwsDeviceTelemetryType[];
  selectedTelemetryId: string | undefined;
  onSelectTelemetry: (telemetry: AwsDeviceTelemetryType) => void;
}

export function AwsTelemetryList({
  telemetries,
  selectedTelemetryId,
  onSelectTelemetry,
}: AwsTelemetryListProps) {
  const { classes } = useStyles();

  return (
    <div className={classes.container}>
      {isEmpty(telemetries) ? (
        <Box sx={{ height: '100%' }}>
          <EmptyState label="No telemetries" />
        </Box>
      ) : (
        telemetries.map((telemetry) => {
          return (
            <TelemetryItem
              key={telemetry.timestamp}
              isActive={selectedTelemetryId === telemetry.timestamp}
              icon={
                <Box sx={{ zIndex: 2 }}>
                  <TelemetryIcon />
                </Box>
              }
              label={prettyTime(telemetry.timestamp)}
              onClick={() => onSelectTelemetry(telemetry)}
            />
          );
        })
      )}
    </div>
  );
}

const useStyles = createStyles((theme) => ({
  container: {
    height: '100%',
    paddingBlock: theme.spacing.xl,
    paddingInline: 32,
  },
}));
